/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';

import {
    Input,
    Spin,
    Form,
    Card,
    Button,
    Modal,
    message,
    Upload,
    Icon,
    Select,
    Modal as AntModal,
} from 'antd';
import './index.less';
import { services } from '@comall-backend-builder/core';
import { ColorPicker, LinkType } from '../../design_page/components/tools';
import { SIDEBARMENU_TYPE_LIST } from '../../constants/page-design';
import { customSelectorConfig } from '../../design';
import { isArray, isObject } from 'lodash';
import moment from 'moment';
import { errorHandle } from '../../services';
const { TextArea } = Input;
const { confirm } = Modal;
const { Option } = Select;

const SidebarMenuAddCom: React.FC<any> = ({ form, params = {} }) => {
    const [spinning, setSpinning] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [fileList, setFileList] = useState<any>([]);
    const [backPic, setBackPic] = useState(''); // 图片地址
    const [detail, setDetail] = useState<any>({});
    const [jumpUrl, setJumpUrl] = useState<any>({
        linkType: 'none',
        linkParams: '',
    });
    const id = params.id ?? '';
    const isChangeLive = params.id && params.idx === '0';

    const isJSON = (str: string) => {
        try {
            JSON.parse(str);
            return true;
        } catch (error) {
            return false;
        }
    };

    const handleGetDetail = () => {
        setSpinning(true);
        services.api
            .get({}, { apiPath: `/appletTab/${id}` })
            .then((res: any) => {
                const { img, linkType, linkTarget, makeDate } = res;
                const formData = { ...res };
                if (makeDate) {
                    formData.makeDate = moment(makeDate).format('YYYY-MM-DD');
                }
                form.setFieldsValue({ ...formData });
                const fileListData = img
                    ? [{ uid: '-1', name: '浮层.png', status: 'done', url: img }]
                    : [];
                setFileList(fileListData);
                setBackPic(img);
                const jumpUrlData = {
                    linkType: linkType,
                    linkParams: linkTarget,
                };
                if (linkTarget && isJSON(linkTarget)) {
                    jumpUrlData.linkParams = JSON.parse(linkTarget);
                }
                setJumpUrl(jumpUrlData);
                setDetail(res);
            })
            .catch((e: any) => {
                errorHandle(e);
            })
            .finally(() => {
                setSpinning(false);
            });
    };

    useEffect(() => {
        form.setFieldsValue({
            fontColor: '#AD7C72',
        });
        if (id) {
            handleGetDetail();
        } else {
            const today = moment().format('YYYY-MM-DD');
            form.setFieldsValue({
                makeDate: today,
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        form.validateFields((err: any, values: any) => {
            if (err || !backPic) {
                message.warning('请先把必填项填写完整！');
                return;
            }
            const { linkType, linkParams } = jumpUrl;
            const serveParams = {
                ...values,
                img: backPic,
                linkType,
                fontColor: values.fontColor || '#AD7C72',
                linkTarget: isObject(linkParams) ? JSON.stringify(linkParams) : linkParams,
            };
            delete serveParams.makeDate;
            if (!id) {
                services.api
                    .post({ ...serveParams }, { apiPath: `/appletTab` })
                    .then(() => {
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            } else {
                services.api
                    .put(
                        {
                            ...serveParams,
                            isShowCharacters: detail.isShowCharacters || 0,
                            isUseImg: detail.isUseImg || 0,
                        },
                        { apiPath: `/appletTab/${id}/updateAppletTab` }
                    )
                    .then(() => {
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            }
        });
    };

    const goBack = () => {
        services.navigation.goto('/design/sidebarMenu');
    };

    // 删除tab
    const showDeleteConfirm = () => {
        confirm({
            title: '确定要删除吗？',
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
                services.api
                    .delete({}, { apiPath: `/appletTab/${id}` })
                    .then(() => {
                        message.success('删除成功！');
                        goBack();
                    })
                    .catch((e: any) => {
                        errorHandle(e);
                    });
            },
            onCancel() {
                console.log('Cancel');
            },
        });
    };

    const handlePreview = async (e: any) => {
        setPreviewImage(e.url || e.thumbUrl);
        setShowPreview(true);
    };

    const handleChange = (e: any) => {
        if (e.file.status === 'done') {
            message.success('上传成功1个，上传失败0个');
        } else if (e.file.status === 'error') {
            message.success('上传成功0个，上传失败1个，请重新上传!');
            setTimeout(() => {
                form.setFieldsValue({ img: undefined });
                setFileList([]);
            }, 20);
        }
        setFileList(e.fileList);
        if (isArray(e.fileList) && e.fileList.length) {
            const cur = e.fileList[0] || {};
            const path = cur?.response?.path;
            setBackPic(path);
        } else {
            setTimeout(() => {
                form.setFieldsValue({ img: undefined });
            }, 20);
        }
    };

    const uploadButton = (
        <div>
            <Icon type="plus" />
            <div className="ant-upload-text">上传</div>
        </div>
    );

    const uploadMsg = (
        <div className="uploadMsg">
            <span>支持jpg/png/gif 格式，图片尺寸建议为</span>
            <br />
            <span>180px*180px</span>
        </div>
    );

    const handleChangePath = (path: any) => {
        setJumpUrl(path);
    };

    const selector: any = customSelectorConfig;

    const { getFieldDecorator } = form;

    return (
        <>
            <Card title={id ? '编辑tab内容' : '新增自义配置'}>
                <Spin spinning={spinning}>
                    <div className="sidebar-add-box">
                        <Form
                            className="ant-advanced-search-form"
                            style={{ marginBottom: '24px' }}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 12 }}
                            onSubmit={handleSubmit}
                        >
                            <Form.Item label="名称">
                                {getFieldDecorator('name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入TAB名称',
                                        },
                                    ],
                                })(<Input disabled={isChangeLive} placeholder="请输入TAB名称" />)}
                            </Form.Item>
                            <Form.Item label="字体颜色">
                                {getFieldDecorator('fontColor')(
                                    <ColorPicker defaultColor="#AD7C72" />
                                )}
                            </Form.Item>
                            <Form.Item label="创建日期">
                                {getFieldDecorator('makeDate')(
                                    <Input disabled placeholder="创建日期" />
                                )}
                            </Form.Item>
                            <Form.Item label="目标描述">
                                {getFieldDecorator('content', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入目标描述',
                                        },
                                    ],
                                })(
                                    <TextArea
                                        disabled={isChangeLive}
                                        placeholder="请输入备注内容"
                                        rows={4}
                                    />
                                )}
                            </Form.Item>
                            <div className="upload-image">
                                <Form.Item label="图片">
                                    {getFieldDecorator('img', {
                                        rules: [{ required: true, message: '请上传图片' }],
                                    })(
                                        <Upload
                                            accept="image/*"
                                            name="fileName"
                                            action={`${ENV.API_ROOT}/images`}
                                            listType="picture-card"
                                            fileList={fileList}
                                            // beforeUpload={handleBeforeUpload}
                                            onPreview={handlePreview}
                                            onChange={handleChange}
                                        >
                                            {fileList.length >= 1 ? null : uploadButton}
                                        </Upload>
                                    )}
                                    {uploadMsg}
                                </Form.Item>
                            </div>

                            <div style={{ marginBottom: 16 }} className="linkType-box">
                                <LinkType
                                    disabled={isChangeLive}
                                    selector={selector}
                                    linkTypes={SIDEBARMENU_TYPE_LIST}
                                    linkTypeMode="select"
                                    value={jumpUrl}
                                    onChange={(path: any) => handleChangePath(path)}
                                />
                            </div>

                            <Form.Item label="使用页面">
                                {getFieldDecorator('position', {
                                    rules: [{ required: true, message: '选择页面使用位置' }],
                                })(
                                    <Select
                                        disabled={isChangeLive}
                                        placeholder="选择页面使用位置"
                                        mode="multiple"
                                    >
                                        <Option value="home">首页</Option>
                                        <Option value="productClassify">商品分类</Option>
                                        <Option value="productList">商品列表</Option>
                                        <Option value="activity">活动专题页</Option>
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item
                                style={{ marginTop: 36 }}
                                wrapperCol={{ span: 12, offset: 9 }}
                            >
                                <Button type="primary" htmlType="submit">
                                    提交
                                </Button>
                                {id && !isChangeLive && (
                                    <Button style={{ marginLeft: 12 }} onClick={showDeleteConfirm}>
                                        删除
                                    </Button>
                                )}

                                <Button style={{ marginLeft: 12 }} onClick={goBack}>
                                    返回
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Spin>

                <AntModal
                    visible={showPreview}
                    footer={null}
                    width={500}
                    style={{ textAlign: 'center' }}
                    onCancel={() => {
                        setShowPreview(false);
                        setPreviewImage('');
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                        }}
                    >
                        <img style={{ width: '100%' }} src={previewImage} alt="" />
                    </div>
                </AntModal>
            </Card>
        </>
    );
};

export const SidebarMenuAdd = Form.create<any>()(SidebarMenuAddCom);
export default SidebarMenuAdd;
